/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Guides/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Chrome from './Chrome/index'
import Edge from './Edge/index'
import React from 'react'
import Safari from './Safari/index'



/** @type {import('Simple/types.js').View} */
export default function Guides({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs/AiRecorder/Content/State/Error/Content/Guides"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Chrome'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Chrome'}>
<Chrome
  viewPath={`${viewPath}/Chrome`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Safari'}>
<Safari
  viewPath={`${viewPath}/Safari`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Edge'}>
<Edge
  viewPath={`${viewPath}/Edge`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}